import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { CadCadastroContato } from 'app/shared/interfaces/cad-cadastro-contato';

/**
 * Formulário de um contato do cadastro — mesmo desenho do popup de endereço: o próprio form
 * grava e o dialog de lista apenas recarrega ao fechar.
 */
@Component({
  selector: 'app-contato-popup',
  templateUrl: './contato-popup.component.html',
  styleUrls: ['./contato-popup.component.scss']
})
export class ContatoPopupComponent implements OnInit {

  contatoForm: FormGroup;
  layoutConf: any;

  /** Mesmos valores do enum Relacao no backend. */
  relacoes = [
    { valor: 'OUTROS', descricao: 'Outros' },
    { valor: 'PAI', descricao: 'Pai' },
    { valor: 'MAE', descricao: 'Mãe' },
    { valor: 'CONJUGE', descricao: 'Cônjuge' },
    { valor: 'DEPENDENTE', descricao: 'Dependente' },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ContatoPopupComponent>,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private loader: AppLoaderService,
    private layout: LayoutService,
    private cadastroService: CadastroService,
  ) { }

  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.buildItemForm(this.data.payload || {});
  }

  buildItemForm(contato: CadCadastroContato) {
    this.contatoForm = this.fb.group({
      id: [contato.id],
      uuid: [contato.uuid],
      // cadastroId é o vínculo com o cadastro dono; sem ele o backend recusa a gravação.
      cadastroId: [contato.cadastroId ?? contato.cadCadastro?.id, Validators.required],
      nome: [contato.nome, Validators.required],
      cargo: [contato.cargo],
      telefone: [contato.telefone],
      obsTelefone: [contato.obsTelefone],
      email: [contato.email, Validators.email],
      dataNasc: [contato.dataNasc],
      relacao: [contato.relacao ?? 'OUTROS'],
    });
  }

  save(): void {
    if (this.contatoForm.invalid) {
      this.contatoForm.markAllAsTouched();
      this.confirmService.confirm({
        title: 'Dados incompletos',
        message: 'Informe pelo menos o nome do contato e verifique o e-mail.', error: true
      });
      return;
    }

    const contato = this.contatoForm.value as CadCadastroContato;
    this.loader.open();
    this.cadastroService.saveOrUpdateContato(contato).subscribe({
      next: salvo => {
        this.loader.close();
        // Mantém o uuid/id devolvidos, para um segundo Salvar atualizar em vez de duplicar.
        this.contatoForm.patchValue({ id: salvo?.id, uuid: salvo?.uuid }, { emitEvent: false });
        this.confirmService.confirm({
          title: 'SALVAR', message: 'OK, Contato salvo com sucesso!', error: false
        });
      },
      error: (err: HttpErrorResponse) => {
        this.loader.close();
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR CONTATO, VERIFIQUE',
          message: err?.error?.status ?? err?.error?.message ?? 'Erro inesperado ao salvar contato.',
          error: true
        });
      }
    });
  }

  close(): void {
    if (this.contatoForm.pristine) {
      this.dialogRef.close();
      return;
    }
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });
  }
}
